module.exports = __webpack_public_path__ + "img/tcsfunding-white-text-only-powered.9112be15.png";